<template lang="pug">
.w-playlist-small

</template>

<script lang="js">

export default {
  name: 'SmallPlaylistWidget',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.w-playlist-small {

}
</style>
